// Shared procedural textures for WORLD COSTA BLANCA visual sculpt.
//
// SOURCE: docs/04-VISUAL-ART-DIRECTION.md — "tactile materials", "limestone /
//   pale façades"; mission brief — limewash/plaster with subtle variation,
//   no dead flat whites (ANTI.flat_white_surfaces, docs/32).
// METHOD: IMPLEMENT — tiny generated canvas texture, shared by every plaster
//   material so cost is one 128x128 texture total.

import * as THREE from 'three';
import { createRng } from '../runtime/rng.js';

let LIMEWASH = null;

/** Subtle whitewash weathering: soft blotches + faint vertical streaks.
 *  Mostly-white so material color tints it (map * color). */
export function limewashTexture() {
  if (LIMEWASH) return LIMEWASH;
  const c = document.createElement('canvas');
  c.width = c.height = 128;
  const g = c.getContext('2d');
  g.fillStyle = '#fdfcf8';
  g.fillRect(0, 0, 128, 128);
  const rng = createRng(41);
  for (let i = 0; i < 240; i += 1) {
    g.fillStyle = `rgba(122,112,96,${.025 + rng() * .05})`;
    g.fillRect(rng() * 128, rng() * 128, 2 + rng() * 10, 2 + rng() * 6);
  }
  for (let i = 0; i < 22; i += 1) {
    g.fillStyle = `rgba(108,98,82,${.02 + rng() * .03})`;
    g.fillRect(rng() * 128, 0, 1 + rng() * 2, 128);
  }
  LIMEWASH = new THREE.CanvasTexture(c);
  LIMEWASH.wrapS = LIMEWASH.wrapT = THREE.RepeatWrapping;
  return LIMEWASH;
}

let CLOUD = null;

/** Soft cel cloud puff: a few overlapping radial blobs on transparent canvas.
 *  Used by the sky module for billboarded clouds (painted, not volumetric). */
export function cloudTexture() {
  if (CLOUD) return CLOUD;
  const c = document.createElement('canvas');
  c.width = 256; c.height = 128;
  const g = c.getContext('2d');
  const rng = createRng(97);
  for (let i = 0; i < 14; i += 1) {
    const x = 40 + rng() * 176;
    const y = 52 + (rng() - .5) * 40;
    const r = 18 + rng() * 26;
    const grad = g.createRadialGradient(x, y, r * .15, x, y, r);
    grad.addColorStop(0, 'rgba(255,255,255,.9)');
    grad.addColorStop(.72, 'rgba(255,255,255,.45)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 256, 128);
  }
  CLOUD = new THREE.CanvasTexture(c);
  return CLOUD;
}
